import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, ReplaySubject } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { MenuEntries } from '../models/menu-entries';
import { keyBy as _keyBy } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private readonly baseUrl;

  private menuEntriesState = new ReplaySubject<object | null>(1);
  private menuEntriesCache$?: Observable<object | null>;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  updateMenuEntries(force?: boolean): void {
    if (!this.menuEntriesCache$ || force) {
      this.menuEntriesCache$ = this.http.get(this.baseUrl + 'menu-entries').pipe(
        map(menu => MenuEntries.deserialize(menu)),
        map(entries => _keyBy(entries)),
        shareReplay()
      );
    }
    this.menuEntriesCache$.subscribe(menuEntries => this.menuEntriesState.next(menuEntries));
  }

  getMenuEntriesState(): Observable<object | null> {
    return this.menuEntriesState.asObservable();
  }
}
